// Name: Messaging Body Render Definitions 

export const EMAIL_EVENT_BODY_RENDER_DEF = {
	email_uid: {displayName: "Email UID"},
	event_type: {displayName: "Event Type"},
	last_updated_timestamp: {displayName: "Last Updated Timestamp"},
	created_timestamp: {displayName: "Created Timestamp"},
	mailgun_email_id: {displayName: "Mailgun Email Id"},
	event_uid: {displayName: "Event UID"}
};

export const EMAIL_TEMPLATE_BODY_RENDER_DEF = {
	email_subject: {displayName: "Email Subject"},
	last_updated_timestamp: {displayName: "Last Updated Timestamp"},
	created_timestamp: {displayName: "Created Timestamp"},
	archived: {displayName: "Archived"},
	internal_name: {displayName: "Internal Name"},
	template_version: {displayName: "Template Version"},
	email_body: {displayName: "Email Body"},
	template_id: {displayName: "Template Id"},
	template_uid: {displayName: "Template UID"}
};

export const MAILBOX_BODY_RENDER_DEF = {
	removed_recipient_account_uids: {displayName: "Removed Recipient Account UIDs"},
	recipient_account_uids: {displayName: "Recipient Account UIDs"},
	last_updated_timestamp: {displayName: "Last Updated Timestamp"},
	created_timestamp: {displayName: "Created Timestamp"},
	creating_account_uid: {displayName: "Creating Account UID"},
	mailbox_uid: {displayName: "Mailbox UID"},
	resource_uid: {displayName: "Resource UID"},
	deposify_tags: {displayName: "Deposify Tags"},
	resource_type: {displayName: "Resource Type"}
};

export const MAILBOX_MESSAGE_BODY_RENDER_DEF = {
	recipient_account_uid: {displayName: "Recipient Account UID"},
	deleted_timestamp: {displayName: "Deleted Timestamp"},
	message_type: {displayName: "Message Type"},
	last_updated_timestamp: {displayName: "Last Updated Timestamp"},
	deleted: {displayName: "Deleted"},
	message_title: {displayName: "Message Title"},
	attached_files_uid: {displayName: "Attached Files UID"},
	message_uid: {displayName: "Message UID"},
	mailbox_uid: {displayName: "Mailbox UID"},
	sender_account_uid: {displayName: "Sender Account UID"},
	read: {displayName: "Read"},
	message_body: {displayName: "Message Body"},
	read_timestamp: {displayName: "Read Timestamp"},
	deposify_tags: {displayName: "Deposify Tags"},
	sent_timestamp: {displayName: "Sent Timestamp"}
};

export const MAILBOX_META_DATA_BODY_RENDER_DEF = {
	meta_data_uid: {displayName: "Meta Data UID"},
	last_updated_timestamp: {displayName: "Last Updated Timestamp"},
	created_timestamp: {displayName: "Created Timestamp"},
	mailbox_uid: {displayName: "Mailbox UID"},
	deposify_tags: {displayName: "Deposify Tags"},
	new_message_count: {displayName: "New Message Count"},
	account_uid: {displayName: "Account UID"}
};

export const SENT_EMAIL_BODY_RENDER_DEF = {
	recipient_account_uid: {displayName: "Recipient Account UID"},
	email_uid: {displayName: "Email UID"},
	last_updated_timestamp: {displayName: "Last Updated Timestamp"},
	resource_type: {displayName: "Resource Type"},
	recipient_email_hash: {displayName: "Recipient Email Hash"},
	created_timestamp: {displayName: "Created Timestamp"},
	recipient_email_address: {displayName: "Recipient Email Address"},
	mailgun_email_id: {displayName: "Mailgun Email Id"},
	resource_uid: {displayName: "Resource UID"},
	template_version: {displayName: "Template Version"},
	template_id: {displayName: "Template Id"},
	email_type: {displayName: "Email Type"}
};

